export default function SubmitBand() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-auto w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20wide%20editorial%20banner%20of%20torn%20crimson%20paper%20edge%20and%20warm%20cream%20texture%20with%20risograph%20grain%2C%20dramatic%20minimal%20collage%20strip%2C%20deep%20shadow%20shapes%2C%20no%20readable%20text&width=1600&height=600&seq=cgbhl-cta-band-01&orientation=landscape"
          alt="补充吃瓜爆黑料导航入口"
          title="补充吃瓜爆黑料导航入口"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/40"></div>

        <div className="relative z-10 mx-auto w-full max-w-[1360px] px-4 py-16 md:px-8 md:py-24">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3">
              <span className="h-px w-10 bg-accent-400"></span>
              <span className="text-xs tracking-[0.34em] text-accent-300">线索与补充</span>
            </div>
            <h2 className="mt-5 font-heading text-2xl leading-snug text-background-50 md:text-4xl">
              还有值得收进册子的入口吗？
            </h2>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-100/85 md:text-base">
              如果你常看的主页、频道或合集还没出现在索引里，欢迎把名字和它擅长什么留下来。
              我们会先去看一眼更新频率，再决定归到哪一册、排在第几位。
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <button
                type="button"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm text-foreground-950 transition-colors hover:bg-accent-600"
              >
                留下入口线索
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-send-plane-line"></i>
                </span>
              </button>
              <a
                href="#channels"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/45 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-background-50/10"
              >
                先看看已有账号
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}